import type { RouteRecordRaw } from 'vue-router'

// Routes of the membership area. meta.account: requires a signed-in account.
// /membership stays public so visitors can read the plans; buying sends them to sign in.
export const routes: RouteRecordRaw[] = [
  { path: '/membership', name: 'membership', component: () => import('./IndexView.vue') },
  { path: '/membership/orders', name: 'membership-orders', component: () => import('./OrdersView.vue'), meta: { account: true } },
  {
    path: '/membership/orders/:orderId',
    name: 'membership-order',
    component: () => import('./OrderView.vue'),
    props: true,
    meta: { account: true },
  },
]
